import logo from './images/logo.png';
import audioBackgroundImage from './images/audio-image.png';
import logoOnly from './images/atlas-logo-only.svg';
import logout from './images/logout-icon.svg';
import dropIcon from './images/drop-icon.svg';
import calendar from './images/calendar-icon.svg';
import notifications from './images/notification-icon.svg';
import emptyScreen from './images/frog.svg';
import dropdownCaret from './images/dropdown-caret.png';
import googleIcon from './images/social-gplus.svg';
import facebookIcon from './images/social-facebook.svg';
import macombFAB from './images/macomb-FAB.svg';
import macombBoard from './images/macomb-board.png';

import archLogo from './images/archLogo.png';

export {
  audioBackgroundImage,
  emptyScreen,
  logo,
  archLogo,
  logoOnly,
  calendar,
  logout,
  dropIcon,
  notifications,
  dropdownCaret,
  googleIcon,
  facebookIcon,
  macombFAB,
  macombBoard,
};
